var version = {
    "name":      "dativery",
    "buildDateCode": "20260929-144303",
    "buildDate": "Tue Sep 29 2026 14:43:03 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260929-144303",
    "backupUIVersion": "2.2.0-20250522-134816"
}
;
 export default version;